var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityGameJams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tab03_filled 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.46 47.0952L17.1864 43.71C16.2812 42.78 15.9588 41.4408 16.368 40.1884C16.678 39.2212 17.112 37.944 17.6204 36.4932H6.39837C5.48077 36.4932 4.63757 35.9848 4.17877 35.1664C3.71997 34.348 3.73237 33.3436 4.20357 32.5252L9.77117 22.8408C11.1476 20.4476 13.64 18.9844 16.3308 18.9844H25.0604C25.3208 18.5504 25.5688 18.1412 25.8292 17.7444C34.5216 4.526 47.4548 4.092 55.18 5.5552C56.42 5.7908 57.3748 6.7828 57.598 8.0476C59.024 16.0332 58.59 29.3632 45.7808 38.3284C45.4088 38.5888 45.012 38.8492 44.5904 39.122V48.1244C44.5904 50.902 43.1644 53.4812 40.8456 54.8948L31.4464 60.636C30.6652 61.1196 29.6856 61.132 28.892 60.6608C28.0984 60.1896 27.6148 59.3216 27.6148 58.3792V46.6488C26.1144 47.182 24.8124 47.616 23.8204 47.9508C22.63 48.3352 21.3404 48.0004 20.46 47.0952ZM44.5904 23.3616C45.7064 23.3616 46.7852 22.9028 47.5912 22.0844C48.3848 21.2536 48.8312 20.15 48.8312 18.9844C48.8312 17.8188 48.3848 16.7152 47.5912 15.8844C46.7852 15.066 45.7064 14.6072 44.5904 14.6072C43.462 14.6072 42.3832 15.066 41.5896 15.8844C40.7836 16.7152 40.3372 17.8188 40.3372 18.9844C40.3372 20.15 40.7836 21.2536 41.5896 22.0844C42.3832 22.9028 43.462 23.3616 44.5904 23.3616Z",
    fill: "#1471C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityGameJams);
export default __webpack_public_path__ + "static/media/activity-game-jams.fdb96f3e3b00316316e7d0638863e549.svg";
export { ForwardRef as ReactComponent };